import { render } from "./SaleableComparison.vue?vue&type=template&id=36160baa"
import script from "./SaleableComparison.vue?vue&type=script&lang=js"
export * from "./SaleableComparison.vue?vue&type=script&lang=js"

import exportComponent from "D:\\agents\\Oreo\\_work\\93\\s\\NcasReporting\\clientapp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__